import TopHeader from "./TopHeader";
import Sidebar from "./sidebar";
import React, { Component } from "react";

class Layout extends Component {
  render() {
    const { children, team } = this.props;
    return (
      <>
        <TopHeader />
        <section className="page-body w-100">
          <div className="col-md-12 p-0">
            <div className="main">
              <Sidebar team={team} />
              {children}
            </div>
          </div>
        </section>
      </>
    );
  }
}

// Layout.propTypes = {
//   children: PropTypes.node.isRequired, // Ensures 'children' is a renderable node and required
//   team: PropTypes.object // Assumes 'team' is an object; adjust type as per your data structure
// };

export default Layout;
